import { Component, OnInit, ViewChild, Directive, Input, OnChanges } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { AplicacionesTransporteService } from "./aplicaciones-transporte.service";
import { AplicacionesTransporteResumen, AplicacionesConsulta } from "../entities/aplicaciones_transporte_entity";
import { UtilService } from "../../../components/common/utils/util.service";
import { PolizaEntity } from "../entities/polizas_cliente_entity";

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'aplicacionesTransporte',
    styleUrls: ["aplicaciones-transporte.style.css"],
    templateUrl: 'aplicaciones-transporte.template.html'
})

export class AplicacionesTransporteComponent implements OnChanges, OnInit {
    usuario: ClienteLogin;
    public showLoader: string;
    usuarioEmpresa: ClienteXCiudad;
    aplicacionesConsultaResult: AplicacionesTransporteResumen[];
    aplicacionesConsulta: AplicacionesConsulta;
    poliza: PolizaEntity;
    @Input() polizaContratada: PolizaEntity;
    bandera: boolean;
    filterQuery: string;
    filterQuery2: string;
    filterQuery3: string;

    constructor(private router: Router, private aplicacionesTransporteService: AplicacionesTransporteService, private sesionStorageService: SessionStorageService, private handleError: HandleError,
        private sessionTokenService: SessionTokenService, public utilsService: UtilService) { }
    
    ngOnInit(){
        this.aplicacionesConsultaResult = new Array<AplicacionesTransporteResumen>();
        this.showLoader = "sk-loading";
        this.bandera = false;
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.usuarioEmpresa = new ClienteXCiudad();
                this.aplicacionesConsulta = new AplicacionesConsulta();
                this.poliza = new PolizaEntity();
                if (this.router.isActive('/patrimoniales/consultas/resumen-aplicaciones-transporte', false) || this.router.isActive('/pymes/consultas/resumen-aplicaciones-transporte', false)) {
                    try{
                    this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioEmpresa"));
                    }catch(e){
                        this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                    }
                    this.cargaTodo();
                    this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                        try {
                            this.usuarioEmpresa = JSON.parse(v);
                            this.cargaTodo();
                        } catch (e) {
                            this.usuarioEmpresa = v;
                            this.cargaTodo();
                        }
                    });
                }else{
                    this.cargaTodoXPoliza();
                    /*this.sesionStorageService.observe("poliza").subscribe(v => {
                        try {
                            this.poliza = JSON.parse(v);
                            this.cargaTodoXPoliza();
                        } catch (e) {
                            this.poliza = v;
                            this.cargaTodoXPoliza();
                        }
                    });*/
                }
            }
        }
    }
    
    ngOnChanges() {
        this.aplicacionesConsultaResult = new Array<AplicacionesTransporteResumen>();
        this.showLoader = "sk-loading";
        this.bandera = false;
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.usuarioEmpresa = new ClienteXCiudad();
                this.aplicacionesConsulta = new AplicacionesConsulta();
                this.poliza = new PolizaEntity();
                if (this.router.isActive('/patrimoniales/consultas/resumen-aplicaciones-transporte', false) || this.router.isActive('/pymes/consultas/resumen-aplicaciones-transporte', false)) {
                    try{
                    this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioEmpresa"));
                    }catch(e){
                        this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                    }
                    this.cargaTodo();
                    this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                        try {
                            this.usuarioEmpresa = JSON.parse(v);
                            this.cargaTodo();
                        } catch (e) {
                            this.usuarioEmpresa = v;
                            this.cargaTodo();
                        }
                    });
                }else{
                    this.cargaTodoXPoliza();
                    /*this.sesionStorageService.observe("poliza").subscribe(v => {
                        try {
                            this.poliza = JSON.parse(v);
                            this.cargaTodoXPoliza();
                        } catch (e) {
                            this.poliza = v;
                            this.cargaTodoXPoliza();
                        }
                    });*/
                }
            }
        }
    }

    cargaTodo() {
        if (this.router.isActive('/patrimoniales/consultas/resumen-aplicaciones-transporte', false)) {
            this.aplicacionesConsulta.segmento = 1;
        }
        if (this.router.isActive('/pymes/consultas/resumen-aplicaciones-transporte', false)) {
            this.aplicacionesConsulta.segmento = 2;
        }
        this.aplicacionesConsulta.cliente = this.usuarioEmpresa;
        this.aplicacionesTransporteService
            .consultarAplicaciones(this.aplicacionesConsulta)
            .subscribe(
            result => {
                this.bandera = true;
                if(result.length != undefined){
                this.aplicacionesConsultaResult = result;
                }else{
                    this.aplicacionesConsultaResult = new Array<AplicacionesTransporteResumen>();
                }
            },
            error => { this.handleError.redirectUrl(error); }
            );
    }

    cargaTodoXPoliza() {
        this.aplicacionesTransporteService
            .consultarAplicacionesXPoliza(this.polizaContratada)
            .subscribe(
            result => {
                this.bandera = false;
                if(result.length != undefined){
                this.aplicacionesConsultaResult = result;
                }else{
                    this.aplicacionesConsultaResult = new Array<AplicacionesTransporteResumen>();
                }
            },
            error => { this.handleError.redirectUrl(error); }
            );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.component.ts